/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-100
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_224 from /* 224 */"./224/index"
import * as /* [auto-meaningful-name] */Module_21 from /* 21 */"./21"
import { createElement, forwardRef } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_610 from /* 610 */"./610"
var $b = {
  icon: {
    tag: "svg",
    attrs: {
      viewBox: "64 64 896 896",
      focusable: "false"
    },
    children: [
      {
        tag: "path",
        attrs: {
          d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
        }
      }
    ]
  },
  name: "check",
  theme: "outlined"
}
var ey = function (e, t) {
  return createElement(Module_224.a, Module_21.a(Module_21.a({}, e), {}, {
    ref: t,
    icon: $b
  }))
}
ey.displayName = "CheckOutlined"
var ty = forwardRef(ey)
export { ty }
